import { convert as convertActivity } from '@/activities/api/activities.js'
import axios, { parseCursor } from '@/base/api/axios'

export default {
  async get (id) {
    return (await axios.get(`/api/conversations/${id}/`)).data
  },

  async list (filter) {
    const response = (await axios.get('/api/conversations/', { params: filter })).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: convertListResults(response.results),
    }
  },

  async save (id, data) {
    return (await axios.patch(`/api/conversations/${id}/`, data)).data
  },

  async markConversationsSeen () {
    return (await axios.post('/api/conversations/mark_conversations_seen/')).data
  },

  async markThreadsSeen () {
    return (await axios.post('/api/conversations/mark_threads_seen/')).data
  },
}

function convertListResults (results) {
  return {
    conversations: results.conversations,
    messages: results.messages,
    activities: convertActivity(results.activities),
    applications: results.applications,
    issues: results.issues,
    offers: results.offers,
    usersInfo: results.usersInfo,
    meta: results.meta,
  }
}
